import { SubSection } from '../ui';
import { ReactNode } from 'react';

interface InstanceProperties {
  id: number;
  onRemove?: (instanceId: number) => void;
  children?: ReactNode
}

const Instance = function({
  children,
  id,
  onRemove
}: InstanceProperties) {
  return (
    <SubSection onRemove={() => { onRemove !== undefined && onRemove(id); }}>
      {children}
    </SubSection>
  );
}

export default Instance;